module.exports = __webpack_public_path__ + "static/media/order_type_app_apple.563fe80d.svg";